import classNames from "classnames";
import React from "react";
import snd_boughtUpgrade from "../../../resources/audio/ui/bought_upgrade.flac";
import BaseEntity from "../../core/entity/BaseEntity";
import Entity from "../../core/entity/Entity";
import { ControllerButton } from "../../core/io/Gamepad";
import { KeyCode } from "../../core/io/Keys";
import { SoundInstance } from "../../core/sound/SoundInstance";
import { ReactEntity } from "./ReactEntity";
import { resetUpgradesAndMoney } from "../upgrade/persistence";
import { getUpgradeManager, UpgradeManager } from "../upgrade/UpgradeManager";
import { getUpgradeById, UpgradeId } from "../upgrade/upgrades";
import "./UpgradeShop.css";

// TODO: Gamepad support
export class UpgradeShop extends BaseEntity implements Entity {
  id = "upgradeShop";
  reactView: ReactEntity<unknown>;

  canBeClosed = false;

  constructor() {
    super();

    this.reactView = this.addChild(
      new ReactEntity(() => <UpgradeShopView {...this.getProps()} />)
    );
  }

  onAdd() {
    this.wait().then(() => (this.canBeClosed = true));
  }

  getProps(): Props {
    const upgradeManager = getUpgradeManager(this.game!);
    return {
      money: upgradeManager.money,
      availableUpgrades: upgradeManager.getAvailableUpgrades(),
      purchasedUpgrades: upgradeManager.getPurchasedUpgrades(),
      upgradeManager,
      buyUpgrade: (upgradeId: UpgradeId) =>
        upgradeManager.buyUpgrade(upgradeId),
    };
  }

  close() {
    if (this.canBeClosed) {
      this.destroy();
    }
  }

  onKeyDown(key: KeyCode) {
    if (key === "KeyE") {
      if (this.canBeClosed) {
        this.close();
      }
    }
  }

  onButtonDown(button: ControllerButton) {
    if (button === ControllerButton.Y) {
      this.close();
    }
  }

  handlers = {
    diverJumped: () => {
      this.destroy();
    },

    upgradeBought: () => {
      this.reactView.reactRender();

      this.game?.addEntity(new SoundInstance(snd_boughtUpgrade, { gain: 0.2 }));
    },
  };
}

interface Props {
  money: number;
  availableUpgrades: UpgradeId[];
  purchasedUpgrades: UpgradeId[];
  upgradeManager: UpgradeManager;
  buyUpgrade: (upgradeId: UpgradeId) => void;
}

function UpgradeShopView({
  money,
  purchasedUpgrades,
  availableUpgrades,
  upgradeManager,
  buyUpgrade,
}: Props) {
  return (
    <div className="UpgradeShop">
      <div className="Money">${money}</div>
      <h1>Upgrades</h1>
      <div className="UpgradeButtons">
        {availableUpgrades.map((upgradeId) => {
          const upgrade = getUpgradeById(upgradeId);
          const affordable = upgradeManager.canAffordUpgrade(upgradeId);
          return (
            <div
              className={classNames("UpgradeButton", { affordable })}
              onClick={() => {
                if (affordable) {
                  buyUpgrade(upgradeId);
                }
              }}
              key={upgradeId}
            >
              <div className="name-and-cost">
                <div className="name">{upgrade.name}</div>
                <div className="cost">${upgrade.cost}</div>
              </div>
              <div className="description">{upgrade.description}</div>
            </div>
          );
        })}
      </div>
      {purchasedUpgrades.length > 0 && (
        <div className="PurchasedUpgrades">
          Purchased:{" "}
          {purchasedUpgrades.map((upgradeId) => (
            <span title={getUpgradeById(upgradeId).description} key={upgradeId}>
              {getUpgradeById(upgradeId).name}
            </span>
          ))}
        </div>
      )}

      <button
        onClick={() => {
          resetUpgradesAndMoney();
        }}
      >
        Reset
      </button>
    </div>
  );
}
